(function (window) {

  /** @typedef {{method:DR.events.GetFilter, drawList:Function, noAjax:Boolean}} SearchMapPar **/

  /**
   * @class
   * @extends mkE.Base
   */
  const SearchMap = Class(
    /**
     * @lends {SearchMap#}
     */
    {
      /** @type {SearchMapPar} */
      par: undefined,
      /** @type {Map<number, google.maps.Marker>} */
      _markers: new Map(),
      /** @type {int} */
      _activeMarker: 0,
      /** @type {google.maps.Marker} */
      _markerListItem: null,
      /** @type {DR.events.SearchMap} */
      _mSearchEvents: null,
      /** @type {google.maps.Map} */
      _map: null,
      /** @type {int} */
      _searchTimeout: 0,
      /** @type {Object|null} */
      _boundsCache: null,
      /** @type {google.maps.Marker} */
      _geoMarker: null,
      /** @type {Boolean} */
      _isFittingBounds: false,
      _mapListenerOnFirstLoad: null,
      _loaderTimeout: 0,
      /**
       * @param {SearchMapPar} par
       */
      __construct (par) {
        this.par = par;
        this.node = mkE({
          tag: 'div',
          className: 'events-map',
          els: [
            this._search = new T.SearchEvents.AutoComplete({
              onChange: this.onSearchChange,
              onResearch: this.onResearch,
              noAjax: this.par.noAjax,
              onSelectEvent: this.onSelectEvent,
            }),
            this._filter = new T.SearchEvents.Filter({
              onChange: this.onFilterChange,
              filterCountry: false,
              method: par.method
            }),
            this._mapNode = mkE({
              tag: 'div',
              className: 'map',
              style: {
                height: D.CSS.brTablet ? '100%' : '749px'
              }
            }),
            this._loader = mkE({
              tag: 'div',
              className: 'map-loader',
              els: [
                {
                  tag: 'div',
                  className: 'button button-gray',
                  els: [
                    {
                      tag: 'div',
                      className: 'dot-flashing'
                    }
                  ]
                }
              ]
            }),
          ]
        });
        if (this.par.drawList) {
          this._btnDrawListContainer = mkE({
            tag: 'a',
            className: 'button button-pink button-draw-list',
            onclick: this.par.drawList,
            els: [
              D.CSS.brTablet ? '' : D.Lang.get('events.list.go-to-list'),
              D.svgIcon('burger')
            ]
          }).append(this.node);
        }
      },
      search (bounds) {
        if (this._map) {
          this._map.fitBounds(bounds);
          this.onSearch();
        } else {
          D.loadGoogleMaps(['drawing']).then(() => {
            D.addJS('/dist/vendor/markerclusterer/index.min.js', this._onGoogleMapLoaded.bind(this, bounds));
          });
        }
      },
      /** @param {MouseEvent|KeyboardEvent|null} e */
      onSearchChange (e) {
        this.onSearch(e !== null);
        if (this._item) {
          this._item.close();
        }
      },
      onFilterChange () {
        // Changing transport type filter, search is sometimes not needed, as the data is already there
        let tt = this._mSearchEvents.transportType, filter = this._filter.getTransportType() || [];
        if (!tt || (filter && tt.filter(x => filter.includes(x)).length === filter.length)) {
          this._markers.forEach(function (marker) {
            if (!filter.length || filter.indexOf(marker.data.type) > -1) {
              this._markerClusterer.addMarker(marker);
            } else {
              this._markerClusterer.removeMarker(marker);
            }
          }, this);
          return;
        }
        this.onSearch();
      },
      onSearch (findOutsideBounds = false) {
        if (!this._mSearchEvents) {
          this._mSearchEvents = new DR.events.SearchMap();
          this._mSearchEvents.onLoad = this._mSearchEventsRe;
        }
        const m = this._mSearchEvents;
        if (m.processing) {
          return;
        }
        m.transportType = this._filter.getTransportType();
        m.tag = this._search.valueTag();
        m.kw = this._search.value() || null;
        m.findOutsideBounds = findOutsideBounds;
        let bounds = this._map.getBounds();
        m.boundsNorthEast = new DR.roadgames.struct.Coordinates();
        m.boundsNorthEast.latitude = bounds.getNorthEast().lat();
        m.boundsNorthEast.longitude = bounds.getNorthEast().lng();
        m.boundsSouthWest = new DR.roadgames.struct.Coordinates();
        m.boundsSouthWest.latitude = bounds.getSouthWest().lat();
        m.boundsSouthWest.longitude = bounds.getSouthWest().lng();
        this._showLoader();
        this._boundsCache = {
          ne: { lat: m.boundsNorthEast.latitude, lng: m.boundsNorthEast.longitude },
          sw: { lat: m.boundsSouthWest.latitude, lng: m.boundsSouthWest.longitude }
        };
        m.call();
        if (!this.par.noAjax) {
          Url.replace(this._getUrl().toUrl());
        }
      },
      _hasFilterChanged () {
        let m = this._mSearchEvents;
        return m.transportType !== this._filter.getTransportType();
      },
      onResearch () {
        let m = this._mSearchEvents;
        if ((!m.findOutsideBounds && !m.re.mapMarkers.length) || this._hasFilterChanged()) {
          this.onSearch(true);
          return;
        }
        this._fitBounds();
      },
      zoomIn () {
        this._map.setZoom(this._map.getZoom() + 1);
      },
      zoomOut () {
        this._map.setZoom(this._map.getZoom() - 1);
      },
      geolocate () {
        navigator.geolocation.getCurrentPosition(
          this._onGeoLocated,
          error => {
            alert(D.Lang.get('events.map.geolocation_error'));
            console.warn(error);
          }, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          });
      },
      _onGoogleMapLoaded (bounds) {
        this._map = new google.maps.Map(this._mapNode, {
          center: {
            lat: 56.81385,
            lng: 24.69367
          },
          zoom: 8,
          minZoom: 4,
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          zoomControl: false,
          gestureHandling: D.CSS.brTablet ? 'greedy' : null,
          styles: [
            {
              'featureType': 'landscape.man_made',
              'elementType': 'geometry',
              'stylers': [
                {
                  'color': '#f9f5ed'
                },
                {
                  'saturation': '0'
                }
              ]
            },
            {
              'featureType': 'landscape.natural',
              'elementType': 'geometry',
              'stylers': [
                {
                  'color': '#f9f5ed'
                }
              ]
            },
            {
              'featureType': 'landscape.natural.terrain',
              'elementType': 'geometry',
              'stylers': [
                {
                  'visibility': 'off'
                }
              ]
            },
            {
              'featureType': 'poi',
              'elementType': 'labels',
              'stylers': [
                {
                  'visibility': 'off'
                }
              ]
            },
            {
              'featureType': 'poi.attraction',
              'elementType': 'all',
              'stylers': [
                {
                  'visibility': 'off'
                }
              ]
            },
            {
              'featureType': 'poi.business',
              'elementType': 'all',
              'stylers': [
                {
                  'visibility': 'off'
                }
              ]
            },
            {
              'featureType': 'poi.medical',
              'elementType': 'geometry',
              'stylers': [
                {
                  'color': '#fbd3da'
                }
              ]
            },
            {
              'featureType': 'poi.park',
              'elementType': 'geometry',
              'stylers': [
                {
                  'color': '#dbeed0'
                }
              ]
            },
            {
              'featureType': 'poi.sports_complex',
              'elementType': 'all',
              'stylers': [
                {
                  'visibility': 'on'
                }
              ]
            },
            {
              'featureType': 'road',
              'elementType': 'geometry.stroke',
              'stylers': [
                {
                  'visibility': 'off'
                }
              ]
            },
            {
              'featureType': 'road',
              'elementType': 'labels',
              'stylers': [
                {
                  'visibility': 'on'
                }
              ]
            },
            {
              'featureType': 'road.highway',
              'elementType': 'geometry.fill',
              'stylers': [
                {
                  'color': '#fcfcdd'
                },
                {
                  'saturation': '0'
                }
              ]
            },
            {
              'featureType': 'road.highway',
              'elementType': 'geometry.stroke',
              'stylers': [
                {
                  'color': '#efd151'
                },
                {
                  'visibility': 'on'
                }
              ]
            },
            {
              'featureType': 'road.arterial',
              'elementType': 'geometry.fill',
              'stylers': [
                {
                  'color': '#ffffff'
                }
              ]
            },
            {
              'featureType': 'road.arterial',
              'elementType': 'geometry.stroke',
              'stylers': [
                {
                  'color': '#dcdcdc'
                },
                {
                  'visibility': 'on'
                }
              ]
            },
            {
              'featureType': 'road.local',
              'elementType': 'geometry.fill',
              'stylers': [
                {
                  'visibility': 'on'
                },
                {
                  'color': '#ffffff'
                }
              ]
            },
            {
              'featureType': 'road.local',
              'elementType': 'geometry.stroke',
              'stylers': [
                {
                  'visibility': 'on'
                },
                {
                  'color': '#d4cdb9'
                }
              ]
            },
            {
              'featureType': 'transit.station.airport',
              'elementType': 'geometry.fill',
              'stylers': [
                {
                  'color': '#e1e6ea'
                }
              ]
            },
            {
              'featureType': 'transit.station.airport',
              'elementType': 'geometry.stroke',
              'stylers': [
                {
                  'color': '#b5c5d2'
                }
              ]
            },
            {
              'featureType': 'water',
              'elementType': 'geometry',
              'stylers': [
                {
                  'color': '#a2daf2'
                }
              ]
            }
          ]
        });
        this._map.fitBounds(bounds);
        this._markerClusterer = new markerClusterer.MarkerClusterer({
          map: this._map,
          algorithm: new markerClusterer.SuperClusterAlgorithm({ radius: 100, maxZoom: 17 }),
          renderer: {
            render: ({ count, position }) => new google.maps.Marker({
              label: {
                text: String(count > 10 ? '10+' : count),
                color: 'white',
                fontSize: '23px',
                fontFamily: '"Fira Sans",sans-serif'
              },
              position,
              // adjust zIndex to be above other markers
              zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
              icon: {
                url: `/assets/images/events/map-marker.svg`,
                anchor: new google.maps.Point(24, 52),
                origin: new google.maps.Point(0, -2),
                scale: 1
              }
            })
          }
        });
        this._mapListenerOnFirstLoad = this._map.addListener('idle', this._onMapListenerOnFirstLoad);
        // Controls
        let controls = mkE({
          tag: 'div',
          className: 'events-map-controls',
          els: [
            {
              tag: 'div',
              className: 'control control-plus',
              onclick: this.zoomIn,
              els: [D.svgIcon('plus')]
            },
            {
              tag: 'div',
              className: 'control control-minus',
              onclick: this.zoomOut,
              els: [D.svgIcon('minus')]
            }
          ]
        }).append(this._mapNode);

        if (navigator.permissions && navigator.geolocation) {
          navigator.permissions.query({ name: 'geolocation' }).then((result) => {
            if (result.state === 'denied') {
              return;
            }
            mkE({
              tag: 'div',
              className: 'control control-location',
              onclick: this.geolocate,
              els: [D.svgIcon('gps')]
            }).append(controls);
          }).catch(error => {
            console.warn(error);
          });
        }
      },
      /** @param {GeolocationPosition} position */
      _onGeoLocated (position) {
        // Marker indicating user geolocation
        if (!this._geoMarker) {
          this._geoMarker = new google.maps.Marker({
            position: {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            },
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 8,
              fillOpacity: 1,
              strokeWeight: 2,
              fillColor: '#5384ED',
              strokeColor: '#ffffff'
            },
            map: this._map
          });
        }
        this._geoMarker.setPosition({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
        if (this._map.moveCamera) {
          this._panTo(
            {
              center: {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              },
              zoom: 13
            },
            1000,
            function (t) {
              // Quadratic easing function
              return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            }
          );
        } else {
          this._map.panTo({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
          this._map.setZoom(13);
          this.onSearch();
        }
      },
      /**
       * @param {Object} opt
       * @param {Number} duration
       * @param {Function} ease
       * @param {Function|null} onEnd
       * @param {Object|null} _f
       * @param {Number|null} time
       * @private
       */
      _panTo (opt, duration, ease, onEnd = null, _f = null, time = null) {
        let progress = 0;
        if (time !== null) {
          if (_f === null) {
            _f = {
              startTime: time,
              opt: {
                center: this._map.getCenter().toJSON(),
                zoom: this._map.getZoom()
              }
            };
          }
          progress = Math.min((time - _f.startTime) / duration, 1);
          const easedProgress = ease(progress);
          this._map.moveCamera({
            center: {
              lat: _f.opt.center.lat + (opt.center.lat - _f.opt.center.lat) * easedProgress,
              lng: _f.opt.center.lng + (opt.center.lng - _f.opt.center.lng) * easedProgress
            },
            zoom: _f.opt.zoom + (opt.zoom - _f.opt.zoom) * easedProgress
          });
        }
        if (progress < 1) {
          requestAnimationFrame(this._panTo.bind(this, opt, duration, ease, onEnd, _f));
        } else if (onEnd) {
          onEnd();
        }
      },
      _onMapListenerOnFirstLoad () {
        google.maps.event.removeListener(this._mapListenerOnFirstLoad);
        this._mapListenerOnFirstLoad = null;
        this._map.addListener('dragend', this._onMapChanged);
        this._map.addListener('zoom_changed', this._onMapChanged);
        this._map.addListener('click', this._onMapClicked);
        this.onSearch();
      },
      _showLoader (timeout = 600) {
        clearTimeout(this._loaderTimeout);
        this._loaderTimeout = setTimeout(() => {
          this._loader.style.display = '';
        }, timeout);
      },
      _hideLoader () {
        clearTimeout(this._loaderTimeout);
        this._loader.style.display = 'none';
      },
      _showError (text = null) {
        if (this._errorNode) {
          this._errorNode.remove();
          clearTimeout(this._errorNode.to);
          this._errorNode = null;
        }
        if (!text) {
          return;
        }
        this._errorNode = mkE({
          tag: 'div',
          className: 'events-map-error',
          text: text
        }).append(this.node);
        this._errorNode.to = setTimeout(this._showError.bind(this, null), 4100);
      },
      _onMapChanged () {
        if (this._isFittingBounds) {
          this._isFittingBounds = false;
          return;
        }
        const tag = this._search.valueTag();
        const kw = this._search.value() || null;
        // If search is set, then dragging the map is not gonna return new results
        if (tag || kw || this._isWithinPreviousSearchBounds()) {
          return;
        }
        clearTimeout(this._searchTimeout);
        // Show fake loader, then search
        this._showLoader(500);
        this._searchTimeout = setTimeout(this.onSearch, 1000);
      },
      _isWithinPreviousSearchBounds () {
        let bounds = this._map.getBounds();
        let ne = bounds.getNorthEast();
        let sw = bounds.getSouthWest();
        let c = this._boundsCache;
        return c !== null && ne.lat() < c.ne.lat && ne.lng() < c.ne.lng && sw.lat() > c.sw.lat && sw.lng() > c.sw.lng;
      },
      _onMapClicked () {
        if (this._item) {
          this._item.close();
        }
      },
      _onClickMarker (id) {
        if (this._activeMarker === id) {
          return;
        }
        if (this._activeMarker) {
          this._setIcon(this._activeMarker, false);
        }
        this._activeMarker = id;
        this._setIcon(this._activeMarker, true);
        if (!this._item) {
          this._item = new SearchMapItem(this._onCloseItem, this.par.noAjax);
          if (D.CSS.brTablet) {
            this._popup = new T.PopupModal({
              onClose: () => {
                this._item.close();
              }
            }).append(this.node);
            this._popup.setContent(this._item.node);
          } else {
            this._item.append(this._mapNode);
          }
        }
        this._item.load(id);
        if (D.CSS.brTablet) {
          this._popup.open();
        }
        if (this._btnDrawListContainer) {
          this._btnDrawListContainer.style.display = 'none';
        }
      },
      _onCloseItem () {
        if (!this._activeMarker) {
          return;
        }
        this._setIcon(this._activeMarker, false);
        this._activeMarker = 0;
        if (this._btnDrawListContainer) {
          this._btnDrawListContainer.style.display = '';
        }
        if (this._popup) {
          this._popup.close();
        }
      },
      _setIcon (id, isActive = false) {
        const marker = this._markers.get(id);
        if (!marker) {
          return;
        }
        let icon = marker.getIcon();
        let active = isActive ? '-active' : '';
        icon.url = `/assets/images/events/map-marker-${marker.data.type}${active}.svg`;
        marker.setIcon(icon);
      },
      _getUrl () {
        const get = new Get(D.url('/events'));
        if (this._mSearchEvents.transportType && this._mSearchEvents.transportType.length < 3) {
          get.add('transportType', this._mSearchEvents.transportType.join(','));
        }
        if (this._mSearchEvents.tag) {
          get.add('tag', this._mSearchEvents.tag);
        }
        if (this._mSearchEvents.kw) {
          get.add('kw', this._mSearchEvents.kw);
        }
        return get;
      },
      _mSearchEventsRe () {
        this._hideLoader();
        const m = this._mSearchEvents;
        let ids = [];
        let addMarkers = [];
        for (let i = 0; i < m.re.mapMarkers.length; i++) {
          const listItem = m.re.mapMarkers[i];
          ids.push(listItem.id);
          if (this._markers.get(listItem.id)) {
            continue;
          }
          let marker = new google.maps.Marker({
            position: {
              lat: listItem.location.latitude,
              lng: listItem.location.longitude
            },
            icon: {
              url: `/assets/images/events/map-marker-${listItem.type}.svg`,
              anchor: new google.maps.Point(20, 40),
              scale: 1
            }
          });
          marker.data = {
            type: listItem.type
          };
          marker.addListener('click', this._onClickMarker.bind(this, listItem.id));
          this._markers.set(listItem.id, marker);
          addMarkers.push(marker);
        }

        this._markers.forEach(function (marker, id) {
          if (ids.indexOf(id) === -1) {
            this._markerClusterer.removeMarker(marker);
            this._markers.delete(id);
          }
        }, this);

        if (addMarkers.length) {
          this._markerClusterer.addMarkers(addMarkers);
        }

        if (!m.re.mapMarkers.length && m.findOutsideBounds) {
          this._showError(D.Lang.get('events.map.error.not_found'));
        }

        if (m.findOutsideBounds) {
          this._fitBounds();
        }
      },
      _fitBounds () {
        if (!this._markers.size) {
          return;
        }
        let bounds = Array.from(this._markers.values()).reduce((bounds, marker) => {
          return bounds.extend(marker.getPosition());
        }, new google.maps.LatLngBounds());
        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
          let extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.005, bounds.getNorthEast().lng() + 0.005);
          let extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.005, bounds.getNorthEast().lng() - 0.005);
          bounds.extend(extendPoint1);
          bounds.extend(extendPoint2);
        }
        this._isFittingBounds = true;
        this._map.fitBounds(bounds);
      },
      onSelectEvent(id) {
        const url = D.url('/event/' + id);
        if(D.APP_WEBVIEW) {
          D.sendPostMessage({
            status: 'open_event',
            seoTitle: id,
            type: null,
          });
        }
        if (this.noAjax) {
          window.location = url;
        } else {
          Section.navigate(url);
        }
      }
    },
    mkE.Base
  );

  /**
   * @class
   * @extends mkE.Base
   */
  const SearchMapItem = Class(
    /**
     * @lends {SearchMapItem#}
     */
    {
      /** @type {DR.events.struct.Event} */
      _event: null,
      /** @type {Function} */
      onClose: null,
      noAjax: false,
      /**
       * @param {Function} onClose
       * @param {Boolean} noAjax
       * @private
       */
      __construct: function (onClose, noAjax) {
        this.onClose = onClose;
        this.noAjax = noAjax === true;
        this.node = mkE({
          tag: 'div',
          className: 'events-map-item',
          els: [
            this.content = mkE({
              tag: 'div',
              className: 'events-map-item__wrapper'
            }),
            !D.CSS.brTablet ? {
              tag: 'a',
              className: 'close',
              onclick: this.close,
              els: [
                D.svgIcon('close')
              ]
            } : null
          ]
        });
      },
      load (id) {
        if (this.apiCall && this.apiCall.processing) {
          // this._mGetEvent.abort();
          return;
        }
        this.node.style.display = '';
        clearTimeout(this._placeHolderTimeout);
        this._placeHolderTimeout = setTimeout(this._drawPlaceHolder, 666);

        this.apiCall = new DR.ApiCall();

        this._mGetEvent = new DR.events.GetEvent();
        this._mGetEvent.onLoad = this._mGetEventRe;
        this._mGetEvent.onError = this._mGetEventError;
        this._mGetEvent.select = [
          new DR.events.select.Event().id().title().image().settings().ticket().userRating().stats().seoTitle().languages().minPlayers().maxPlayers().description().gallery().regionImage().landing().hasTeam(),
          new DR.roadgames.select.Image().medium().original()
        ];
        this._mGetEvent.eventId = id;
        this.apiCall.addMethod(this._mGetEvent);

        this.apiCall.call({
          eventId: id
        });
      },
      close () {
        if (this._mGetEvent.processing) {
          // this._mGetEvent.abort();
        }
        if (!D.CSS.brTablet) {
          clearNode(this.content);
          this.node.style.display = 'none';
        }
        this.onClose();
      },
      _mGetEventRe () {
        this._event = this._mGetEvent.re;
        this._draw();
      },
      _mGetEventError () {
        clearTimeout(this._placeHolderTimeout);
        clearNode(this.content);
        mkE({
          tag: 'div',
          className: 'event-error',
          els: [
            {
              tag: 'h4',
              text: D.Lang.get('events.map.item.error')
            },
            {
              tag: 'p',
              text: D.Lang.get('events.map.item.errorDescription')
            }
          ]
        }).append(this.content);
      },
      _drawPlaceHolder () {
        clearNode(this.content);
        if (D.CSS.brTablet) {
          this._drawMobilePlaceholder();
        } else {
          this._drawWebPlaceholder();
        }
      },
      _draw () {
        clearTimeout(this._placeHolderTimeout);
        clearNode(this.content);
        if (D.CSS.brTablet) {
          this._drawMobile();
        } else {
          this._drawWeb();
        }
      },
      _drawWebPlaceholder () {
        mkE({
          tag: 'div',
          className: 'event placeholder',
          els: [
            {
              tag: 'div',
              className: 'event-image'
            },
            {
              tag: 'div',
              className: 'event-container',
              els: [
                { tag: 'div' },
                { tag: 'div' }
              ]
            }
          ]
        }).append(this.content);
      },
      _drawWeb () {
        const event = this._event;
        mkE({
          tag: 'div',
          className: 'event',
          onclick: this._onClick,
          els: [
            {
              tag: 'div',
              className: 'event-image',
              style: {
                backgroundImage: event.landing.pic ? `url("${event.landing.pic.medium}")` : `url("${event.image.medium}")`
              },
              els: [
                {
                  tag: 'div',
                  className: 'event-image-container',
                  els: [
                    {
                      tag: 'h4',
                      text: event.title
                    }
                  ]
                }
              ]
            },
            {
              tag: 'div',
              className: 'event-rating-price',
              els: [
                this._price(),
                this._rating()
              ]
            },
            this._quick(),
            this._description(),
            this._gallery()
          ]
        }).append(this.content);
      },
      _drawMobilePlaceholder () {
        mkE({
          tag: 'div',
          className: 'event placeholder',
          els: [
            {
              tag: 'div',
              className: 'event-container',
              els: [
                { tag: 'div' }
              ]
            },
            {
              tag: 'div',
              className: 'event-image'
            }
          ]
        }).append(this.content);
      },
      _drawMobile () {
        const event = this._event;
        let image = event.image.medium;
        if (event.landing.picMobile) {
          image = event.landing.picMobile.medium;
        } else if (event.landing.pic) {
          image = event.landing.pic.medium;
        }
        mkE({
          tag: 'div',
          className: 'event',
          onclick: this._onClick,
          els: [
            {
              tag: 'h4',
              text: event.title
            },
            {
              tag: 'div',
              className: 'event-image',
              style: {
                backgroundImage: `url("${image}")`
              }
            },
            {
              tag: 'div',
              className: 'event-rating-price',
              els: [
                this._price(),
                this._rating()
              ]
            },
            this._quick()
          ]
        }).append(this.content);
      },
      _price () {
        const event = this._event;
        const re = {
          tag: 'div',
          className: 'event-price'
        };

        if (D.SITE_B2B) {
          re.els = [
            {
              tag: 'a',
              href: D.url('/event/' + event.seoTitle),
              className: 'button button-small button-turquoise',
              text: D.Lang.get('b2b.event.open'),
              onclick: this._onClick,
            }
          ];
          return re;
        }

        if (event.hasTeam) {
          re.els = [
            {
              tag: 'a',
              href: D.url('/profile/event/' + event.seoTitle),
              className: 'button button-small button-turquoise',
              text: D.Lang.get('event.myTeam'),
              onclick: this._onClick
            }
          ];
          return re;
        }
        if (event.settings.isFreeGame) {
          re.els = [
            {
              tag: 'div',
              className: 'button-container',
              els: [
                {
                  tag: 'a',
                  href: D.url(D.Lang.get('home.welcome.button.link')),
                  className: 'button button-small button-pink',
                  text: D.Lang.get('home.welcome.button'),
                  onclick: this._onClick
                }
              ]
            },
            {
              tag: 'div',
              className: 'price-container',
              els: [
                {
                  tag: 'div',
                  className: 'price',
                  text: D.Lang.get('event.freeGame')
                }
              ]
            }
          ];
          return re;
        }
        let activePriceIndex = event.ticket.prices.findIndex(price => price.isActive);
        if (activePriceIndex === -1) {
          return '';
        }
        let currentPrice = Object.assign({}, event.ticket.prices[activePriceIndex]);
        let nextPrice = null;
        if (event.ticket.prices[activePriceIndex + 1]) {
          nextPrice = Object.assign({}, event.ticket.prices[activePriceIndex + 1]);
        }
        if (event.settings.ticketPerPerson) {
          currentPrice.price *= event.minPlayers;
          if (nextPrice) {
            nextPrice.price *= event.minPlayers;
          }
        }
        let discountAmount = D.SESSION_DISCOUNT_AMOUNT;
        let data = this.discountData;
        if (event.ticket.hasFirstAffiliateDiscount) {
          data = event.ticket.firstAffiliateDiscount;
        } else if (event.ticket.hasAffiliateDiscount) {
          data = event.ticket.affiliateDiscount;
        }
        if (data) {
          switch (data.type) {
            case 'static':
              discountAmount = data.amount;
              break;
            case 'percent':
              discountAmount = currentPrice.price * data.amount / 100;
              break;
          }
        }
        re.els = [
          {
            tag: 'div',
            className: 'button-container',
            els: [
              {
                tag: 'a',
                href: D.url('/profile/event/' + event.seoTitle + '/create'),
                className: 'button button-small button-pink',
                text: D.Lang.get('event.open_event'),
                onclick: this._onClickBuy,
              }
            ]
          },
          {
            tag: 'div',
            className: 'price-container',
            els: [
              nextPrice || discountAmount ? {
                tag: 'div',
                className: 'next-price',
                text: '€' + ((nextPrice ? nextPrice.price : currentPrice.price) / 100).toFixed(2)
              } : null,
              {
                tag: 'div',
                className: 'price',
                text: '€' + ((currentPrice.price - discountAmount) / 100).toFixed(2)
              }
            ]
          }
        ];
        return re;
      },
      _rating () {
        const event = this._event;
        if (event.isNewGame) {
          return {
            tag: 'div',
            className: 'event-rating new',
            els: [
              {
                tag: 'span',
                els: [
                  {
                    tag: 'b',
                    text: D.Lang.get('events.new_event')
                  }
                ]
              },
              event.settings.gameType === 'race' && event.stats.players >= 10 ? {
                tag: 'span',
                els: [
                  ' · ',
                  D.Lang.nget(event.stats.players, 'event.users_played')
                ]
              } : ''
            ]
          };
        } else {
          return {
            tag: 'div',
            className: 'event-rating',
            els: [
              {
                tag: 'span',
                els: [
                  {
                    tag: 'b',
                    text: event.userRating.rating ? event.userRating.rating.toFixed(2) : '-'
                  },
                  event.userRating.users ? ' (' + event.userRating.users + ')' : ''
                ]
              },
              ' · ',
              D.Lang.nget(event.stats.players, 'event.users_played')
            ]
          };
        }
      },
      _quick () {
        const event = this._event;
        return {
          tag: 'div',
          className: 'event-quick',
          els: [
            {
              tag: 'div',
              els: [
                event.stats.pins > 0 ? {
                  tag: 'div',
                  className: 'item',
                  els: [
                    D.svgIcon('pins'),
                    event.stats.pins
                  ]
                } : '',
                {
                  tag: 'div',
                  className: 'item',
                  els: [
                    D.svgIcon('time'),
                    RoadgamesEvent.getEventDuration(event)
                  ]
                },
                {
                  tag: 'div',
                  className: 'item',
                  els: [
                    D.svgIcon('transport-type-' + event.settings.transportType),
                    D.Lang.get('event.transport.' + event.settings.transportType)
                  ]
                }
              ]
            },
            {
              tag: 'div',
              els: [
                event.stats.distance > 0 ? {
                  tag: 'div',
                  className: 'item',
                  els: [
                    D.svgIcon('distance'),
                    Math.round(event.stats.distance / 1000) + ' km'
                  ]
                } : '',
                {
                  tag: 'div',
                  className: 'item',
                  els: [
                    D.svgIcon('team'),
                    event.minPlayers === event.maxPlayers ? `${event.maxPlayers}` : `${event.minPlayers} -${event.maxPlayers}`
                  ]
                },
                {
                  tag: 'div',
                  className: 'item',
                  els: [
                    D.svgIcon('languages'),
                    event.languages.join(', ').toUpperCase()
                  ]
                }
              ]
            }
          ]
        };
      },
      _description () {
        const event = this._event;
        let limit = 240;
        let description = event.description.substring(0, limit);
        let readMore = '';
        if (event.description.length > limit) {
          description = description.trim() + '... ';
          readMore = {
            tag: 'span',
            className: 'read-more',
            text: D.Lang.get('events.infoblock.description.expand')
          };
        }
        return {
          tag: 'div',
          className: 'event-description',
          els: [
            {
              tag: 'p',
              els: [
                description,
                readMore
              ]
            }
          ]
        };
      },
      _tasks () {
        const tasks = RoadgamesEvent.getEventTasks(this._event);
        let re = [];
        for (let i = 0; i < tasks.length; i++) {
          const task = tasks[i];
          re.push({
            tag: 'div',
            els: [
              D.svgIcon(`task-${task}`),
              D.CSS.brTablet ? '' : {
                tag: 'span',
                className: 'text',
                text: D.Lang.get('how-to.' + task + '.caption')
              }
            ]
          });
        }
        return {
          tag: 'div',
          className: 'event-tasks',
          els: re
        };
      },
      _gallery () {
        const event = this._event;
        const par = {
          isStatic: true
        };
        if (event.regionImage) {
          event.gallery.unshift(new DR.roadgames.struct.Pic({
            image: event.regionImage
          }));
          par.overlay = mkE({
            tag: 'div',
            className: 'region-image'
          });
        }
        if (!event.gallery.length) {
          return;
        }
        return {
          tag: 'div',
          className: 'event-gallery',
          els: [
            new T.GalleryBlock(event.gallery, par)
          ]
        };
      },
      _onClickBuy (e) {
        this._onClick(e, 'buy');
      },
      _onClick (e, type) {
        type = type || null;
        e.stopPropagation();
        e.preventDefault();
        const url = e.currentTarget.href || D.url('/event/' + this._event.seoTitle);
        if(D.APP_WEBVIEW) {
          D.sendPostMessage({
            status: 'open_event',
            seoTitle: this._event.seoTitle,
            type: type,
          });
        }
        if (this.noAjax) {
          window.location = url;
        } else {
          Section.navigate(url);
        }
      }
    },
    mkE.Base
  );

  window.T.EventsSearchMap = SearchMap;

})(window);
